module.exports = __webpack_public_path__ + "assets/media/level10-user-icon.b7f507ce.png";